var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Tabs"},[_c('TabsHead',{attrs:{"active":_vm.active,"tabs":_vm.slots},on:{"update:active":function($event){_vm.active=$event}}}),_c('div',{staticClass:"body"},[_vm._t(_vm.selectedSlot)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }